// extracted by mini-css-extract-plugin
export default {"appIconContainer":"HomeListApp_appIconContainer__hkCXo","cardBgOpacity":"HomeListApp_cardBgOpacity__q6oII"};